import { onFCP } from 'web-vitals/attribution';
import type { FCPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';
import { toFcpReport } from './mappers';

const onFirstContentfulPaint = (report: (m: MetricReport) => void): void => {
  onFCP((metric: FCPMetricWithAttribution) => {
    report(toFcpReport(metric));
  });
};

export default onFirstContentfulPaint;
